import React from "react"

export const UserIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.50033 5.14783C5.50033 6.539 6.61962 7.66667 8.00033 7.66667C9.38105 7.66667 10.5003 6.539 10.5003 5.14783V4.51883C10.5003 3.12767 9.38105 2 8.00033 2C6.61962 2 5.50033 3.12767 5.50033 4.51883V5.14783ZM2.66699 11.6667C2.66699 9.89333 6.22032 9 8.00032 9C9.78032 9 13.3337 9.89333 13.3337 11.6667V13C13.3337 13.7364 12.7367 14.3333 12.0003 14.3333H4.00033C3.26395 14.3333 2.66699 13.7364 2.66699 13V11.6667Z"
        fill="#21A038"
      />
    </svg>
  )
}
